import {useAuthStore} from '@toolify/client/src/stores/AuthStore/useAuthStore'
import {
  ExperimentalFeatureFlagType,
} from '@toolify/server/src/models/mongoose/UserModel/enum/ExperimentalFeatureFlagType'
import {computed} from 'vue'
import {EntityType} from '@toolify/server/src/services/EntityService/enum/EntityType'
import {IUserResponseInstance} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/IUserResponseInstance'

export function useExperimentalFeatureFlag() {
  const authStore = useAuthStore()

  const isExperimentalFeatureFlagEnabled = computed(() => {
    const user = authStore.currentEntity?.entityType === EntityType.User
      ? authStore.currentEntity.payload as IUserResponseInstance
      : null
    const experimentalFeatureFlags = user?.experimentalFeatureFlags || []
    return (experimentalFeatureFlag: ExperimentalFeatureFlagType): boolean => {
      return experimentalFeatureFlags?.includes(experimentalFeatureFlag) || false
    }
  })
  
  return {
    isExperimentalFeatureFlagEnabled,
  }
}
